import { ReadonlySection } from '@/components/form/readonly-view/section';
import { ConnectorModel } from '@/lib/models/connector/connector.model';
import { PrivateModelModel } from '@/lib/models/private-model/private-model.model';
import { Box, Stack } from '@mui/material';
import { FC } from 'react';
import PrivateModelReadonlyView from './readonly-view';
import PrivateModelTestCard from './test-card';

interface Props {
  model: PrivateModelModel;
  connector: ConnectorModel;
  onTest: () => void;
}

const PrivateModelDetails: FC<Props> = ({ model, connector, onTest }) => {
  return (
    <Stack gap={2}>
      <PrivateModelReadonlyView model={model} connector={connector} />
      <Box>
        <ReadonlySection label="Testing" />
        <PrivateModelTestCard model={model} onTest={onTest} />
      </Box>
    </Stack>
  );
};

export default PrivateModelDetails;
